module.exports = __webpack_public_path__ + "static/media/channels-svgrepo.a6a27dde.svg";